import axios from "axios";
import { SERVER_URL } from "../config";

/* =========================================================
   FETCH SEASONS
========================================================= */
export const fetchSeasons = async () => {
  try {
    const res = await axios.get(
      `${SERVER_URL}/seasonWiseTransaction.php`,
      { params: { action: "getSeasons" } }
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching seasons:", err);
    throw err;
  }
};

/* =========================================================
   FETCH REGIONS
========================================================= */
export const fetchRegions = async () => {
  try {
    const res = await axios.get(
      `${SERVER_URL}/seasonWiseTransaction.php`,
      { params: { action: "getRegions" } }
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching regions:", err);
    throw err;
  }
};

/* =========================================================
   FETCH PARTIES (OPTIONAL REGION)
========================================================= */
export const fetchParties = async (region = "") => {
  try {
    const res = await axios.get(
      `${SERVER_URL}/seasonWiseTransaction.php`,
      {
        params: {
          action: "getParties",
          region,
        },
      }
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching parties:", err);
    throw err;
  }
};

/* =========================================================
   SEASON WISE TRANSACTION REPORT
========================================================= */
export const fetchSeasonWiseTransactionReport = async ({
  fromDate,
  toDate,
  region = "",
  party = "",
  search = "",
  paymentType = "",   // 👈 ADD THIS
}) => {
  try {
    const res = await axios.get(
      `${SERVER_URL}/seasonWiseTransaction.php`,
      {
        params: {
          action: "getReport",
          fromDate,
          toDate,
          region,
          party,
          search,
          paymentType,   // 👈 AND THIS
        },
      }
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching season wise transaction report:", err);
    throw err;
  }
};


export const fetchPaymentTypes = async () => {
  try {
    const res = await axios.get(
      `${SERVER_URL}/seasonWiseTransaction.php`,
      { params: { action: "getPaymentTypes" } }
    );

    const data = Array.isArray(res.data)
      ? res.data
      : [];

    return data.map((item) => {
      if (typeof item === "string") {
        return item.charAt(0).toUpperCase() + item.slice(1);
      }

      return item;
    });

  } catch (err) {
    console.error("Error fetching payment types:", err);
    throw err;
  }
};
